<div class="data-entry-table-cell">
  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoadingData">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading data...</p>
  </div>

  <!-- Data Table -->
  <div class="table-container" *ngIf="!isLoadingData && columns.length > 0">

    <!-- Toolbar -->
    <div class="toolbar">
      <button mat-raised-button
              color="primary"
              *ngFor="let btn of addRowButtons"
              (click)="onAddRow(btn)"
              [disabled]="isEditMode"
              class="add-btn">
        <mat-icon>add</mat-icon>
        {{ btn.label }}
      </button>
    </div>

    <!-- Custom table -->
    <div class="custom-table">
      <div class="table-header" #tableHeader>
        <div class="header-row">
          <div class="header-cell sortable" *ngFor="let column of getDisplayedColumns(); trackBy: trackByColumn"
               (click)="onSortColumn(column)">
            <div class="header-wrapper">
              <div class="header-content">
                <span class="header-text">{{ column.displayName }}</span>
                <mat-icon class="sort-icon" *ngIf="sortColumn === column.fieldName">
                  {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                </mat-icon>
              </div>
            </div>
          </div>

          <!-- Delete Header -->
          <div class="header-cell delete-header" *ngIf="allowDeleteRows">
            <div class="header-wrapper">
              <div class="header-content">
                <span class="header-text"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-body" #tableBody>
        <div class="body-row"
             *ngFor="let row of rows; let rowIndex = index; trackBy: trackByRow">

          <div class="body-cell editable-cell"
               *ngFor="let column of getDisplayedColumns(); trackBy: trackByColumn">
            <!-- Calculated column -->
            <span *ngIf="isCalculatedColumn(column)" class="cell-calculated">
              {{ getCalculatedValue(row, column) }}
            </span>
            <!-- Dropdown column -->
            <select *ngIf="!isCalculatedColumn(column) && isDropdownColumn(column)"
                    class="cell-select"
                    [ngModel]="stringify(row[column.fieldName])"
                    (ngModelChange)="onCellValueChange(row, column.fieldName, $event)"
                    (click)="$event.stopPropagation()">
              <option value="">-- Select --</option>
              <option *ngFor="let opt of getDropdownOptions(column.fieldName)" [ngValue]="stringify(opt.value)">
                {{ opt.label }}
              </option>
            </select>
            <!-- Free entry columns -->
            <ng-container *ngIf="!isCalculatedColumn(column) && !isDropdownColumn(column)">
              <input *ngIf="!isDateColumn(column)"
                     class="cell-input"
                     [type]="isNumericColumn(column) ? 'number' : 'text'"
                     [value]="row[column.fieldName] ?? ''"
                     (change)="onCellValueChange(row, column.fieldName, $any($event.target).value)"
                     (click)="$event.stopPropagation()">
              <input *ngIf="isDateColumn(column)"
                     class="cell-input"
                     type="date"
                     [value]="row[column.fieldName] ?? ''"
                     (change)="onCellValueChange(row, column.fieldName, $any($event.target).value)"
                     (click)="$event.stopPropagation()">
            </ng-container>
          </div>

          <!-- Delete Button -->
          <div class="delete-cell" *ngIf="allowDeleteRows">
            <button mat-icon-button
                    class="delete-btn"
                    (click)="onDeleteRow(rowIndex, $event)"
                    matTooltip="Delete row">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="rows.length === 0">
      <mat-icon>table_rows</mat-icon>
      <p>No rows yet</p>
      <small *ngIf="addRowButtons.length > 0">Use the buttons above to add rows</small>
    </div>
  </div>

  <!-- Loading columns -->
  <div class="no-dataset" *ngIf="!isLoadingData && cell.dataBinding?.datasetId && columns.length === 0">
    <mat-spinner diameter="30"></mat-spinner>
    <p>Loading schema...</p>
  </div>

  <!-- No Dataset Selected -->
  <div class="no-dataset" *ngIf="!cell.dataBinding?.datasetId">
    <mat-icon>dataset</mat-icon>
    <p>No dataset selected</p>
    <small>Configure this cell to select a dataset</small>
  </div>
</div>
